export type SalesDeskOrder = {
  id: string;
  customer: string;
  serial: string | null;
  model: string;
  saleStatus: string;
  fulfillment: string;
  createdAt: string;
  updatedAt: string;
  eventHint: string;
};

export function salesDeskSaleStatusLabel(status: string): string {
  const trimmed = status.trim();
  if (!trimmed) return "Open";
  return trimmed
    .replace(/_/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function salesDeskFulfillmentFromHint(hint: string): string {
  if (hint === "customer_order_delivered") return "Delivered";
  if (hint === "customer_order_submitted") return "Submitted";
  return "No build linked";
}

export function salesDeskFulfillmentLabel(unit: {
  phase: string | null;
  stagedAt: string | null;
  buildCompletedAt: string | null;
} | null): string {
  if (!unit) return "No build linked";
  const phase = unit.phase?.trim() ?? "";
  if (phase) return phase;
  if (unit.stagedAt) return "Staged";
  if (unit.buildCompletedAt) return "Build complete";
  return "Build not started";
}

export function salesDeskOrderCustomer(displayName: string | null, id: string): string {
  const name = displayName?.trim() ?? "";
  return name || `Sale ${id.slice(0, 8)}`;
}

export function filterSalesDeskOrders(orders: SalesDeskOrder[], query: string): SalesDeskOrder[] {
  const q = query.trim().toLowerCase();
  if (!q) return orders;
  return orders.filter((order) => {
    const haystack = [order.customer, order.id, order.serial ?? "", order.model, order.saleStatus, order.fulfillment]
      .join(" ")
      .toLowerCase();
    return haystack.includes(q);
  });
}
